import axios from 'axios'



const whatsappApiClient = axios.create({
  baseURL: process.env.MIX_SOCKET_API_URL,

  headers: {
    'content-type': 'application/json',
    'accept': 'application/json',
    'apikey': process.env.MIX_SOCKET_API_KEY,
  },
})


function commonExceptions(statusCode) {
  switch (statusCode) {
  case 401:
    throw new Error('Não autorizado, cheque sua chave de acesso.')

  case 404:
    throw new Error('Endpoint da API não localizado.')

  case 500:
    throw new Error('Erro interno no servidor, tente novamente mais tarde')

  default:
    throw new Error('Ocorreu um erro na conexão')
  }
}

function getSessionConfigured(sessions, sessionName) {
  const whatsappSession = sessions.find(session => session.name === sessionName)

  if (!whatsappSession)
    throw new Error(`Sessão ${sessionName} não foi encontrada`)

  return whatsappSession
}

export async function getWhatsappSessionUuid() {
  try {
    const response = await whatsappApiClient.get('/instance/fetchInstances')

    if (!response.data.length)
      throw new Error('Nanhuma sessão encontrada')

    return getSessionConfigured(response.data, process.env.MIX_WHATSAPP_SESSION)
  }

  catch (error) {

    if (axios.isAxiosError(error) && error.response)
      commonExceptions(error.response.status)

    throw error
  }

}



export async function disconnectWhatsappSession(sessionName) {
  try {
    const response = await whatsappApiClient.delete(`/instance/logout/${sessionName}`)
    return response.data
  }

  catch (error) {
    if (error.response)
      commonExceptions(error.response.status)

    throw new Error('Error ao fazer conexão')
  }
}

export async function getWhatsappQrCode(sessionName) {
  try {
    const response = await whatsappApiClient.get(`/instance/connect/${sessionName}`)
    return response.data
  }

  catch (error) {
    if (error.response)
      commonExceptions(error.response.status)

    throw new Error('Error ao fazer conexão')
  }
}

export async function getWhatsappGroups(sessionName) {
  try {
    const response = await whatsappApiClient.get(`/group/fetchAllGroups/${sessionName}`, {
      params: {
        getParticipants: false,
      },
    })
    return response.data
  }

  catch (error) {
    if (error.response)
      commonExceptions(error.response.status)

    throw new Error('Error ao fazer conexão')
  }
}


export async function startWhatsappSession(sessionName) {
  try {
    const response = await whatsappApiClient.post(`/instance/restart/${sessionName}`, {})
    return response.data
  }

  catch (error) {
    if (error.response)
      commonExceptions(error.response.status)

    throw new Error('Error ao fazer conexão')
  }
}
